import {BoxContainer, insertAnnot, removeAnnot} from "/@back@/edit/wed/wedlets/box/boxTags.js";
import {IParentWedlet, IWedlet} from "/@back@/edit/wed/wedlets/wedlet.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import "/@back@/edit/wed/wedlets/wedlets_Perms.js";
import {isWedletSingleElt, IWedletSingleElt} from "/@back@/edit/wed/wedlets/wedletSingleElt.js";
import {ISkAnnot} from "/@lib@/edit/schema/schemaAnnots.js";

/**
 * Widget vide déportant son contenu dans une structure ancêtre.
 */
export class BoxMoved extends BoxContainer {

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.wedlet = wedlet as IParentWedlet & IWedletSingleElt;
		let targetSr: ShadowRoot;
		const closest = this.getAttribute("closestTarget");
		if (closest) {
			this.removeAttribute("closestTarget");
			let targetWedlet = wedlet.wedParent;
			while (isWedletSingleElt(targetWedlet)) {
				if (targetWedlet.element.matches(closest)) {
					targetSr = targetWedlet.element.shadowRoot;
					break;
				}
				targetWedlet = targetWedlet.wedParent
			}
		} else {
			const wedletUp = Number.parseInt(this.getAttribute("upToWedletTarget"));
			if (wedletUp > 0) {
				this.removeAttribute("upToWedletTarget");
				let targetWedlet = wedlet
				for (let i = 0; i < wedletUp; i++) targetWedlet = targetWedlet?.wedParent;
				targetSr = (targetWedlet as IWedletSingleElt)?.element?.shadowRoot;
			}
		}
		let parentInsert: Node = targetSr || this;
		const parentPath = this.getAttribute("parentInTarget")
		if (parentPath) {
			this.removeAttribute("parentInTarget");
			parentInsert = targetSr.querySelector(parentPath) || targetSr;
		}
		let nextSibInsert: Node = null;
		const nextSibPath = tpl.getAttribute("nextSiblingInTarget")
		if (nextSibPath) {
			this.removeAttribute("nextSiblingInTarget");
			for (let ch = parentInsert.firstChild; ch; ch = ch.nextSibling) {
				if (ch instanceof Element && ch.matches(nextSibPath)) {
					nextSibInsert = ch;
					break;
				}
			}
		}
		const movedRoot = <box-static/> as BoxContainer;
		movedRoot.attachShadow({mode: "open"});
		for (let att of this.attributes) movedRoot.setAttributeNode(att.cloneNode());
		movedRoot.configWedletElt(tpl, wedlet);
		this.subEltWedlets = [movedRoot];
		this.setDelegatedHost(movedRoot);
		parentInsert.insertBefore(movedRoot, nextSibInsert);
	}

	disconnectedCallback() {
		this.subEltWedlets[0]?.remove();
	}

	drawAnnot(annot: ISkAnnot): boolean {
		if (!this.wedlet) return false; //raceCond
		const movedRoot = this.subEltWedlets[0] as BoxContainer;
		if (movedRoot.drawAnnot(annot)) return true;
		if (this === this.wedlet.element) {
			insertAnnot(movedRoot, annot);
			return true;
		}
		return false;
	}

	eraseAnnot(annot: ISkAnnot): boolean {
		if (!this.wedlet) return false; //raceCond
		const movedRoot = this.subEltWedlets[0] as BoxContainer;
		if (movedRoot.eraseAnnot(annot)) return true;
		if (this === this.wedlet.element) return removeAnnot(movedRoot, annot);
		return false;
	}
}

window.customElements.define("box-moved", BoxMoved);
